import { OrmObjectItem } from "@natiwi/core/models/object-item";
import { NatMainController } from "@natiwi/core/controllers/main.controller";

export abstract class NatObjectItemController<Model extends OrmObjectItem> extends NatMainController<Model>{

    constructor() {
        super();
    }
    
}